import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { LocationStrategy } from "@angular/common";
import { WebsiteThemeService } from "../../services/website-theme.service";
import { WebClientService } from "../../services/webclient-settings.service";
let DepositAddressWarningModalComponent = class DepositAddressWarningModalComponent {
    constructor(sanitizer, router, location, themeService, webSettingsService) {
        this.sanitizer = sanitizer;
        this.router = router;
        this.location = location;
        this.themeService = themeService;
        this.webSettingsService = webSettingsService;
        this.user = {};
        this.confirmMessage = false;
        this.continueButtonDisabled = true;
        this.themeService.getTheme().subscribe((data) => {
            this.backColor = this.themeService.getStyleAttribute('modal_back_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
            this.textColor = this.themeService.getStyleAttribute('text_color');
            this.successColor = this.themeService.getStyleAttribute('success_color');
            this.mainColor = this.themeService.getStyleAttribute('main_color');
        });
        location.onPopState(() => {
            this.close();
        });
    }
    ngOnInit() {
    }
    close() {
        this.modal.destroy();
    }
    closeAndReturn() {
        this.close();
        this.success();
    }
};
DepositAddressWarningModalComponent.ctorParameters = () => [
    { type: DomSanitizer },
    { type: Router },
    { type: LocationStrategy },
    { type: WebsiteThemeService },
    { type: WebClientService }
];
DepositAddressWarningModalComponent = __decorate([
    Component({
        selector: 'ecd-deposit-address-warning-modal',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./deposit-address-warning-modal.component.html")).default
    })
], DepositAddressWarningModalComponent);
export { DepositAddressWarningModalComponent };
